import { useScrollReset } from '@perpay-web/hooks/useScrollReset';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './LegacyFocusLayout.scss';

const LIGHT_MODE = 'light';
const DARK_MODE = 'dark';

/** @deprecated will be removed once we convert all legacy flows to the new FocusLayout (previously known as FocusLayoutV2) */
const LegacyFocusLayout = ({
    children,
    footer,
    className = '',
    // Legacy multiple classname prop. Do not duplicate this pattern.
    // https://perpay.atlassian.net/wiki/spaces/PERPAY/pages/3282567207/Components+should+own+their+own+styles
    // eslint-disable-next-line @perpay-web/no-multiple-classname-props
    contentClassName = '',
    // Legacy multiple classname prop. Do not duplicate this pattern.
    // https://perpay.atlassian.net/wiki/spaces/PERPAY/pages/3282567207/Components+should+own+their+own+styles
    // eslint-disable-next-line @perpay-web/no-multiple-classname-props
    footerClassName = '',
    mode = LIGHT_MODE,
    resetScroll = true,
}) => {
    useScrollReset(resetScroll);

    const modeClassName =
        mode === DARK_MODE ? styles['focus-layout--dark'] : '';
    const modeFooterClassName =
        mode === DARK_MODE ? styles['focus-layout__footer--dark'] : '';
    return (
        <div
            className={getClassName(
                styles['focus-layout'],
                modeClassName,
                className,
            )}
        >
            <div
                className={getClassName(
                    styles['focus-layout__content'],
                    contentClassName,
                )}
            >
                {children}
            </div>
            <div
                className={
                    footerClassName ||
                    getClassName(
                        styles['focus-layout__footer'],
                        modeFooterClassName,
                    )
                }
            >
                {footer}
            </div>
        </div>
    );
};

export default LegacyFocusLayout;
